<template>
  <main-layout>
    <v-container>
      <h3 class="headline">{{ $t('facebook_template') }}</h3>
      <v-container fluid grid-list-md class="pa-0 mt-3" :style="{ width: '100% !important' }">
        <v-layout wrap align-center>
          <v-flex :xs12="$vuetify.breakpoint.xsOnly" class="form-control">
            <input
              v-model="query"
              type="text"
              :placeholder="$t('Search')"
              class="ma-0"
              @input="debounceSearch()"
            />
          </v-flex>
          <v-flex :xs12="$vuetify.breakpoint.xsOnly" shrink>
            <v-btn color="primary" class="ma-0" @click="handleAdd()">
              <v-icon>add</v-icon>
              {{ $t('Add') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
      <div class="mt-3">
        <FacebookTemplateList
          :items="items"
          :page="filters.page"
          :total-pages="Math.ceil(total / filters.limit)"
          @update:page="handlePageUpdate"
        >
          <div v-if="isLoading" class="text-xs-center py-3">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>
          <template v-else-if="!isLoading && total > 0">
            <FacebookTemplateItem
              v-for="(item, itemIndex) in items"
              :key="item.id"
              :value="item"
              active-toggleable
              editable
              deletable
              @input="handleItemInput(itemIndex, $event)"
              @edit="handleEdit(item)"
              @deleted="handleDeleted"
            ></FacebookTemplateItem>
          </template>
          <div v-else class="text-xs-center py-3 grey--text">{{ $t('No data') }}</div>
        </FacebookTemplateList>
      </div>
    </v-container>

    <FacebookTemplateFormDialog
      :open.sync="isFormDialogOpen"
      :value="selectedItem"
      @submitted="handleFormSubmitted"
    ></FacebookTemplateFormDialog>
  </main-layout>
</template>

<script>
import facebookTemplateApi from '@/api/facebook-template'
import debounce from 'lodash/debounce'
import { mapGetters } from 'vuex'
import FacebookTemplateFormDialog from './FacebookTemplateFormDialog.vue'
import FacebookTemplateItem from './FacebookTemplateItem.vue'
import FacebookTemplateList from './FacebookTemplateList.vue'

export default {
  components: {
    FacebookTemplateList,
    FacebookTemplateItem,
    FacebookTemplateFormDialog
  },
  data() {
    return {
      items: [],
      query: '',
      filters: {
        query: '',
        page: 1,
        limit: 10
      },
      total: 0,
      selectedItem: null,
      isLoading: true,
      isFormDialogOpen: false,
      debounceSearch: debounce(() => {
        this.filters = { ...this.filters, query: this.query }
      }, 1000)
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  watch: {
    filters: {
      immediate: true,
      handler() {
        this.fetchFacebookTemplates()
      }
    }
  },
  methods: {
    async fetchFacebookTemplates() {
      try {
        this.isLoading = true

        const response = await facebookTemplateApi.getAll({
          params: {
            page_id: this.selectedBot.pageid,
            name: this.filters.query,
            limit: this.filters.limit,
            offset: (this.filters.page - 1) * this.filters.limit
          }
        })

        if (response.status === 200) {
          this.items = response.data.data
          this.total = response.data.total
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.isLoading = false
      }
    },
    handlePageUpdate(page) {
      this.filters = { ...this.filters, page }
    },
    handleAdd() {
      this.selectedItem = null
      this.isFormDialogOpen = true
    },
    handleEdit(item) {
      this.selectedItem = item
      this.isFormDialogOpen = true
    },
    handleDeleted() {
      this.filters = { ...this.filters }
    },
    handleFormSubmitted() {
      this.isFormDialogOpen = false

      if (this.selectedItem) {
        this.filters = { ...this.filters }
        return
      }

      this.filters = { ...this.filters, query: '', page: 1 }
    },
    handleItemInput(index, newItem) {
      this.items = this.items.map((item, itemIndex) => {
        if (itemIndex === index) {
          return newItem
        }
        return item
      })
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/view/facebook-template/FacebookTemplate.vue